import '@archetype-themes/scripts/vendors/flickity';
import '@archetype-themes/scripts/vendors/flickity-fade';
import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/init-observer';
import '@archetype-themes/scripts/helpers/utils';
import '@archetype-themes/scripts/modules/product-ajax-form'

class FeaturedTagCollections extends HTMLElement {
  constructor() {
    super();
    this.tagsType = this.dataset.tagstype;
    this.slidesToShow = parseInt(this.dataset.slidesToShow) || 4;
    this.collectionButtons = this.querySelectorAll('.featured-collection-button');
    this.buttons = this.querySelectorAll('.featured-tag-button');
    this.panels = this.querySelectorAll('.featured-tag-panel');
    this.tabs = this.querySelectorAll('.featured-tag-tab');
    this.showmore = this.querySelector('.featured-tag-button--showmore');
    this.headButtons = this.querySelector('.featured-tag-buttons');
    this.carousels = [];

    Array.from(this.collectionButtons).forEach(function (btn) {
      btn.addEventListener('click', this.switchCollection.bind(this));
    }, this);

    if (this.tagsType == 'link') {
      Array.from(this.buttons).forEach(function (btn) {
        btn.addEventListener('click', this.switchTab.bind(this));
      }, this);
    }

    if (this.showmore) {
      this.showmore.addEventListener('click', this.showTagbutton.bind(this));
    }

    // Initialize carousels
    this.initCarousels();
  }

  initCarousels() {
    const carouselContainers = this.querySelectorAll('.product-grid--carousel');
    
    carouselContainers.forEach((container) => {
      const items = container.querySelectorAll('.grid-product');

      if (items.length > 4) {
        const flickityInstance = new Flickity(container, {
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          adaptiveHeight: false,
          setGallerySize: true,
          wrapAround: true,
          cellAlign: 'left',
          watchCSS: true
        });
        
        this.carousels.push({
          element: container,
          flickity: flickityInstance
        });
      }
    });
  }

  destroyCarousels() {
    this.carousels.forEach((carousel) => {
      if (carousel.flickity) {
        carousel.flickity.destroy();
      }
    });
    this.carousels = [];
  }

  reinitCarousels() {
    this.destroyCarousels();
    this.initCarousels();
  }
  switchCollection(e) {
    e.preventDefault();
    let panel_index = e.target.dataset.panel;
    Array.from(this.collectionButtons).forEach(function (btn) {
      if (btn.dataset.panel != panel_index) {
        btn.classList.remove('active');
      } else {
        btn.classList.add('active');
      }
    }, this);
    Array.from(this.panels).forEach(function (panel) {
      if (panel.dataset.panel != panel_index) {
        panel.classList.remove('active');
      } else {
        panel.classList.add('active');
      }
    }, this);
    
    // Refresh carousels after switching
    setTimeout(() => {
      this.carousels.forEach((carousel) => {
        if (carousel.flickity) {
          carousel.flickity.resize();
        }
      });
    }, 100);
  }
  switchTab(e) {
    e.preventDefault();
    let tab_index = e.target.dataset.index;
    let current_panel = this.querySelector('.featured-tag-panel.active');
    Array.from(this.buttons).forEach(function (btn) {
      if (btn.closest('.featured-tag-panel') == current_panel) {
        if (btn.dataset.index != tab_index) {
          btn.classList.remove('active');
        } else {
          btn.classList.add('active');
        }
      }

    }, this);
    Array.from(this.tabs).forEach(function (tab) {
      if (tab.closest('.featured-tag-panel') == current_panel) {
        if (tab.dataset.index != tab_index) {
          tab.classList.remove('active');
        } else {
          tab.classList.add('active');
        }
      }
    }, this);
    
    // Refresh carousels after switching tabs
    setTimeout(() => {
      this.carousels.forEach((carousel) => {
        if (carousel.flickity) {
          carousel.flickity.resize();
        }
      });
    }, 100);
  }
  showTagbutton(e) {
    e.preventDefault();
    if (this.showmore.classList.contains('show')) {
      this.headButtons.style.maxHeight = '130px';
      this.showmore.classList.remove('show');
      this.headButtons.style.paddingBottom = '0';
    } else {
      this.headButtons.style.maxHeight = 'unset';
      this.headButtons.style.paddingBottom = '20px';
      this.showmore.classList.add('show');
    }
  }
}

customElements.define('featured-tag-collections', FeaturedTagCollections);